import { InvoiceForCurrencyForLegalEntity, Transaction, TransactionPaymentMedia, TransactionType } from '@ravago/shared/page-data/models/elements';

import { isOverDue } from './invoice-date.utils';

export const canPayInvoiceOnline = (invoice: Transaction) => invoice.paymentMedia === TransactionPaymentMedia.WIRE_TRANSFER;

export const canSelectInvoice = (invoice: Transaction) => canPayInvoiceOnline(invoice) && invoice.type === TransactionType.INVOICE;

export const getInvoicesForLegalEntityAndCurrency = (openInvoices: InvoiceForCurrencyForLegalEntity[], legalEntity: string, currency: string) =>
   openInvoices.find((i) => i.legalEntity === legalEntity)?.currencyTransactions?.find((ct) => ct.currency === currency)?.transactions;

export const getInvoicesForPaymentType = (invoices: Transaction[], selectedInvoiceIds: number[], paymentType: 'selected' | 'open' | 'overdue') => {
   if (paymentType === 'selected') return invoices.filter((invoice) => selectedInvoiceIds.includes(invoice.id));
   if (paymentType === 'open') return invoices.filter(canSelectInvoice);
   return invoices.filter((invoice) => invoice.dueDate && isOverDue(invoice.dueDate) && canSelectInvoice(invoice));
};
